exports = module.exports = require("./../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\r\n.overlay {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  opacity: 1;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0,0,0,.75);\r\n  -webkit-transition: opacity 300ms;\r\n  -moz-transition: opacity 300ms;\r\n  transition: opacity 300ms;\r\n  z-index: 500;\r\n}\r\n\r\n.overlay.hidden {\r\n  pointer-events: none;\r\n  opacity: 0;\r\n}\r\n\r\n.overlay.closable {\r\n  cursor: pointer;\r\n}\r\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/overlay-component/overlay.css
 ** module id = 2
 ** module chunks = 0
 **/